/* ============================================================================
   Balance Phone · lead magnet landing page.

   Four jobs, in this order:

     1. the gate      only visitors who arrived from an ad see the page
     2. attribution   keep what the ad link said, first touch, for 90 days
     3. the fit       photo height = text height, width from its own ratio
     4. the capture   POST the email, reveal the Download button

   The gate is a doorman, not a lock. Anyone holding an ad link, or reading the
   page source, gets in. Shopify Liquid cannot read query parameters, so the
   page HTML is identical for everyone and the decision has to happen in the
   browser. If a real lock is ever needed, the page has to move off the theme
   and behind the storefront service.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('bp-lead-magnet');
  if (!root) return;

  var ENDPOINT = root.getAttribute('data-endpoint') || '';
  var MAGNET   = root.getAttribute('data-magnet') || '';
  var LOCALE   = (root.getAttribute('data-locale') || 'en').toLowerCase().slice(0, 2);
  var HOME     = root.getAttribute('data-home') || '/';
  var GATED    = root.getAttribute('data-gated') === 'true';

  /* --------------------------------------------------------- attribution
     Copied deliberately from bp-quiz.js rather than shared. The two want to
     stay in step and one day should be one file; extracting it means editing
     live quiz code, which does not belong in the landing page's first change.

     Two keys longer than the quiz's list: gclid, gbraid and wbraid. They appear
     nowhere in the theme today, which means every Google Ads click records as
     organic, and Google is around 40% of spend. */
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term',
                   'utm_content', 'meta_campaign_id', 'meta_adset_id',
                   'meta_ad_id', 'placement', 'lm',
                   'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid'];
  var ATTR_TTL = 90 * 24 * 60 * 60 * 1000;

  function attrStored(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || 'null');
      if (!v || Date.now() - Date.parse(v._ts) > ATTR_TTL) return null;
      return v;
    } catch (e) { return null; }
  }

  function readAttribution() {
    var hit = {};
    try {
      var qs = new URLSearchParams(window.location.search);
      ATTR_KEYS.forEach(function (k) {
        if (qs.get(k)) hit[k] = String(qs.get(k)).slice(0, 200);
      });
      if (!Object.keys(hit).length) return null;
      hit._ts = new Date().toISOString();
      localStorage.setItem('bp_last', JSON.stringify(hit));      /* always */
      if (!attrStored('bp_first'))                               /* once */
        localStorage.setItem('bp_first', JSON.stringify(hit));
    } catch (e) {
      /* private browsing throws. The visit still counts, it just records as
         organic, which is the same fallback the quiz takes. */
      return Object.keys(hit).length ? hit : null;
    }
    return hit;
  }

  /* ---------------------------------------------------------------- gate
     Arrived from an ad = the URL carries a marker now, or carried one within
     the last 90 days. The second half matters: people click an ad, leave, and
     come back later from history on a clean URL, and they are the ones most
     likely to convert.

     Always open in the theme editor, or the page cannot be edited. */
  function arrivedFromAnAd(hitNow) {
    if (window.Shopify && window.Shopify.designMode) return true;
    if (hitNow) return true;
    return Boolean(attrStored('bp_first'));
  }

  var hit = readAttribution();
  if (GATED && !arrivedFromAnAd(hit)) {
    window.location.replace(HOME);
    return;
  }
  root.setAttribute('data-gate', 'open');

  /* ----------------------------------------------------------------- fit
     Measured in the ASK state and held there: the done state is shorter, and a
     photo that resizes the moment the button is pressed reads as a glitch. */
  var shot = root.querySelector('.bp-lm__shot');
  var body = root.querySelector('.bp-lm__body');
  var img  = shot && shot.querySelector('img');

  function fit() {
    if (!shot || !body || !img) return;
    if (window.matchMedia('(max-width:749px)').matches) { shot.style.width = ''; return; }
    var ratio = (img.naturalWidth && img.naturalHeight)
      ? img.naturalWidth / img.naturalHeight
      : 0.687;
    var h = body.getBoundingClientRect().height;
    if (h > 0) shot.style.width = Math.round(h * ratio) + 'px';
  }
  fit();
  if (img && !img.complete) img.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fit, 120);
  });

  /* ------------------------------------------------------------- capture */
  var form    = root.querySelector('.bp-lm__form');
  var gate    = root.querySelector('.bp-lm__gate');
  var input   = root.querySelector('.bp-lm__input');
  var pot     = root.querySelector('.bp-lm__pot input');
  var error   = root.querySelector('.bp-lm__error');
  var download = root.querySelector('.bp-lm__btn--download');
  var consent = root.querySelector('.bp-lm__fine');
  if (!form || !gate) return;

  function fail() {
    if (error) error.hidden = false;
    var btn = form.querySelector('.bp-lm__btn');
    if (btn) { btn.disabled = false; btn.textContent = form.getAttribute('data-submit-label') || ''; }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (error) error.hidden = true;

    var btn = form.querySelector('.bp-lm__btn');
    btn.disabled = true;
    btn.textContent = form.getAttribute('data-sending-label') || '';

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: input ? input.value : '',
        lm: MAGNET,
        locale: LOCALE,
        /* the exact sentence they read, in their language, stored as the
           consent record. A consent we cannot quote is not a consent. */
        consent_text: consent ? consent.textContent.trim() : '',
        page_url: window.location.href,
        company: pot ? pot.value : '',
        first_touch: attrStored('bp_first') || hit || {}
      })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (out) {
        if (!out || !out.ok) return Promise.reject('no');
        /* the endpoint owns the document URL, so the button and the email can
           never point at different files. The section setting is only a
           fallback for the day the endpoint answers without one. */
        if (out.url && download) download.setAttribute('href', out.url);
        gate.setAttribute('data-state', 'done');
      })
      .catch(fail);
  });
})();
